export default function calculNbFacesReseauPersonnalise(produits) {
  let nbFaces = 0;
  if (!produits || !produits.length) {
    return 0;
  }
  produits.forEach((el) => {
    nbFaces += el.nbFaces;
  });
  return nbFaces;
}



// WEBPACK FOOTER //
// ./src/services/catalogue/calculNbFacesReseauPersonnalise.js